import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateCurriculumRequirementForm from "../../forms/CreateOrUpdateCurriculumRequirementForm";
import { CurriculumRequirementResponseDto } from "../../shared/dtos/curriculum/CurriculumRequirementResponseDto";

interface UpdateCurriculumRequirementModalProps {
  open: boolean;
  onClose: () => void;
  requirement: CurriculumRequirementResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateCurriculumRequirementModal: React.FC<
  UpdateCurriculumRequirementModalProps
> = ({ open, onClose, requirement, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Edit Requirement"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateCurriculumRequirementForm
      isEditing={true}
      requirement={requirement}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateCurriculumRequirementModal;
